module.exports = __webpack_public_path__ + "img/P1000880.a7c22ebb.jpg";